module.exports = __webpack_public_path__ + "static/img/background.fc55265.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/background.jpg
// module id = WNzc
// module chunks = 16